export const abi = [
  {
    type: 'function',
    name: 'deploy',
    constant: false,
    inputs: [
      {
        type: 'address'
      },
      {
        type: 'bytes32'
      }
    ],
    outputs: [],
    payable: true,
    stateMutability: 'payable'
  }
] as const
